module.exports = __webpack_public_path__ + "static/media/samopistcy.17582724.pdf";